import React, { useCallback } from "react";
import { IOpenPanel } from "../../../../interfaces/base/IPanel";
import { PanelHeader } from "../../../../components/PanelHeader/PanelHeader";
import { PanelFooter } from "../../../../components/PanelFooter/PanelFooter";
import { Panel, PanelType, TextField, Toggle } from "@fluentui/react";
import { UseUbicacionCrear } from "./UseUbicacionCrear";
import { MessageBarResponse } from "../../../../components/MessageBar/MessageBarResponse";
import { ProgressBarLoading } from "../../../../components/ProgressBarLoading/ProgressBarLoading";

const PanelUbicacionCrear = (props: IOpenPanel) => {
  const {
    command,
    setCommand,
    postInsertarUbicacion,
    loading,
    disableForm,
    cerrarPanel,
    mensaje,
    status,
  } = UseUbicacionCrear(props);

  const onRenderHeader = useCallback(
    () => (
      <>
        <PanelHeader
          nameIconHeader="add"
          textHeader={`Movilizaciones`}
          subTextHeader={`Agregar nuevo lugar`}
        />
      </>
    ),
    []
  );

  const onRenderFooter = useCallback(
    () => (
      <>
        <PanelFooter
          texto="Agregar"
          // texto2={"Salir"}
          disableButton={disableForm}
          onClick={postInsertarUbicacion}
          onDismiss={cerrarPanel}
        />
      </>
    ),
    [command, disableForm]
  );

  return (
    <>
      <Panel
        type={PanelType.smallFixedFar}
        onRenderHeader={onRenderHeader}
        onRenderFooter={!loading && mensaje == "" ? onRenderFooter : undefined}
        isFooterAtBottom
        isOpen={props.isOpen}
        onDismiss={props.onDismiss}
      >
        <div className="ms-Grid" dir="ltr">
          <div hidden={mensaje == ""}>
            <MessageBarResponse
              objetoResponse={{ codigo: status, mensaje: mensaje }}
              close={true}
            />
          </div>
          <div hidden={!loading}>
            <ProgressBarLoading></ProgressBarLoading>
          </div>
          <div className="ms-Grid-row" hidden={loading || mensaje != ""}>
            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
              <TextField
                type="text"
                label="Código de la Ubicación:"
                placeholder="Ingrese código"
                autoComplete="off"
                value={command.codigo}
                onChange={(event, newValue) => {
                  if (newValue != null) {
                    setCommand({ ...command, codigo: newValue });
                  }
                }}
              />
            </div>
          </div>

          <div className="ms-Grid-row" hidden={loading || mensaje != ""}>
            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
              <TextField
                type="text"
                label="Nombre de la Ubicación:"
                placeholder="Ingrese Nombre"
                autoComplete="off"
                value={command.nombre}
                onChange={(event, newValue) => {
                  if (newValue != null) {
                    setCommand({ ...command, nombre: newValue });
                  }
                }}
              />
            </div>

            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
              <Toggle
                label="Requiere Bus"
                placeholder="placeholder"
                onText="Si"
                offText="No"
                checked={command ? command.requiereTransporte : false}
                onChange={(e, checked) =>
                  setCommand({ ...command, requiereTransporte: !!checked })
                }
              />
            </div>
            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
              <Toggle
                label="Requiere Vuelo Comercial"
                placeholder="placeholder"
                onText="Si"
                offText="No"
                checked={command ? command.requiereVueloComercial : false}
                onChange={(e, checked) =>
                  setCommand({ ...command, requiereVueloComercial: !!checked })
                }
              />
            </div>
          </div>
        </div>
      </Panel>
    </>
  );
};

export { PanelUbicacionCrear };
